<template>
  <responsive-controller>
    <template #tablet>
      <screen-header
        :history-mode="false"
        :title="$t('common.subscriptions')"
        @navigate="$router.push({ name: 'cabinet' })"
      />
    </template>
    <template #default>
      <div>
        <navigate-button
          v-absolute
          v-left="-80"
          @navigate="$router.push({ name: 'cabinet' })"
        />
        <div v-d-flex>
          <screen-title :title="$t('common.subscriptions')" />
          <simple-button
            v-if="periodicRecurrentPaymentPermission"
            v-m-l="'auto'"
            variant="secondary"
            size="small"
            :fluid="false"
            @click="$router.push({ name: 'Invoicing', hash: '#subscription' })"
          >
            {{ $t('organize.subscription') }}
          </simple-button>
        </div>
      </div>
    </template>
  </responsive-controller>
</template>

<script>
import { mapGetters } from 'vuex';

import ScreenTitle from 'molecules/screen/ScreenTitle';
import ScreenHeader from 'molecules/screen/ScreenHeader';
import NavigateButton from 'molecules/common/NavigateButton';
import SimpleButton from 'molecules/common/SimpleButton';

export default {
  name: 'SubscriptionsHeader',
  components: {
    ScreenTitle,
    ScreenHeader,
    NavigateButton,
    SimpleButton,
  },
  computed: {
    ...mapGetters(['periodicRecurrentPaymentPermission']),
  },
};
</script>
